import { useMonitor } from "@suse-o11y/signal";
import React from "react";

import { Input } from "~/components/input";

import type { FormState } from "./form-state";

export interface WidgetMetricLabelProps {
	name: string;
	metricLabel: FormState;
}

export const WidgetMetricLabel: React.FC<WidgetMetricLabelProps> = ({ name, metricLabel }) => {
	const monitor = useMonitor();

	return (
		<Input
			name={name}
			onChange={(event) => metricLabel.setInput(event.target.value)}
			value={metricLabel.getInput(monitor)}
		/>
	);
};
